import React from 'react';

// Espace réservé : ici vous pourrez plus tard authentifier des admins et charger des images
// vers un stockage (Cloudinary, S3) et les afficher côté Produits.

const Admin = () => {
  return (
    <section className="section">
      <h2>Espace admin (à implémenter)</h2>
      <div className="card">
        <p>Prochaines étapes suggérées :</p>
        <ol>
          <li>Ajouter une authentification (Firebase Auth, Auth0, etc.).</li>
          <li>Uploader des photos vers un stockage cloud.</li>
          <li>Gérer un catalogue produits (CRUD) et le lire côté vitrine.</li>
        </ol>
      </div>
    </section>
  );
};

export default Admin;
